import { useEffect, useRef, useState } from 'react';

const useInView = (
    options?: IntersectionObserverInit
): [React.RefObject<HTMLElement>, boolean] => {
    const ref = useRef<HTMLElement | null>(null);
    const [isInView, setIsInView] = useState(false);

    useEffect(() => {
        const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsInView(true);
                    observer.unobserve(entry.target);
                }
            },
            {
                threshold: isMobile ? 0.05 : 0.75,
                ...options
            }
        );

        const currentElement = ref.current;
        if (currentElement) observer.observe(currentElement);

        return () => {
            if (currentElement) observer.unobserve(currentElement);
        };
    }, [options]);

    return [ref, isInView];
};

export default useInView;
